// extracted by mini-css-extract-plugin
export default {"SkillsWrapper":"skills_SkillsWrapper__emkCK","Skills":"skills_Skills__HDTHb","Skill":"skills_Skill__lBvUI","Text":"skills_Text__w1rbV"};